import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { Chapter, RevealLines, FadeUp } from "./motion";

function Card({ t }) {
  return (
    <div
      data-testid={`testimonial-${t.name.split(" ")[0].toLowerCase()}`}
      className="relative w-[340px] shrink-0 rounded-xl border hairline bg-white p-8 shadow-[0_8px_32px_rgba(27,27,27,0.04)] md:w-[420px]"
    >
      <span className="absolute -top-6 left-6 font-display text-7xl leading-none text-[#B68D40]">&ldquo;</span>
      <div className="flex gap-1 pt-4">
        {Array.from({ length: t.rating }).map((_, i) => (
          <Star key={i} size={14} className="fill-[#B68D40] text-[#B68D40]" />
        ))}
      </div>
      <p className="mt-4 font-serif2 text-base leading-relaxed text-[#2C2C2C] md:text-lg">{t.text}</p>
      <div className="mt-6 flex items-center justify-between border-t hairline pt-5">
        <div>
          <p className="font-display text-sm font-semibold text-[#1B1B1B]">{t.name}</p>
          <p className="mt-0.5 text-[11px] uppercase tracking-widest text-[#2C2C2C]/50">{t.loc}</p>
        </div>
        <span className="flex items-center gap-1.5 rounded-full border hairline px-3 py-1 text-[10px] font-semibold text-[#2C2C2C]/60">
          <span className="font-num font-bold text-[#4285F4]">G</span> Google Review
        </span>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const row = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section id="testimonials" data-testid="testimonials-section" className="overflow-hidden bg-[#F7F5F2] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Chapter num="07" title="Client Stories" />
        <div className="mt-8 flex flex-wrap items-end justify-between gap-6">
          <RevealLines
            className="font-display text-4xl tracking-tight text-[#1B1B1B] md:text-6xl"
            lines={[<>Loved by <span className="italic text-[#B68D40]">100+</span></>, <>Bengaluru families.</>]}
          />
          <FadeUp delay={0.3}>
            <div className="flex items-center gap-3 rounded-full border hairline bg-white px-5 py-3">
              <span className="font-num text-xl font-bold text-[#4285F4]">G</span>
              <div>
                <div className="flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <Star key={i} size={12} className="fill-[#B68D40] text-[#B68D40]" />
                  ))}
                </div>
                <p className="text-[10px] text-[#2C2C2C]/60">5.0 · Verified Google Reviews</p>
              </div>
            </div>
          </FadeUp>
        </div>
      </div>

      <FadeUp delay={0.2} className="marquee-paused mt-16">
        <div className="animate-marquee-fast flex w-max gap-6 pl-6">
          {row.map((t, i) => (
            <Card key={i} t={t} />
          ))}
        </div>
      </FadeUp>
    </section>
  );
}
